import React, { PureComponent } from 'react';
import style from './styles/style.module.css';

export default class CardGrid extends PureComponent {
    render() {
        var className = `${ style.cardGrid } ${ this.props.className }`.trim();
        return (
            <div className={ className } id={ this.props.id }>
                { this.props.children }
            </div>
        );
    }
}
CardGrid.defaultProps = {
    className: '',
    children: null,
};
